import { Row } from "@circle-react-uikit/SkeletonLoader/components/Row";

export const PlanSummarySkeleton = () => (
  <div className="border-primary mt-4 flex w-[375px] flex-col gap-y-3 rounded-xl border p-6">
    <div className="bg-tertiary h-5 w-full animate-pulse rounded-md" />
    <Row md half />
    <Row md half />
    <div className="border-primary flex flex-col gap-y-2 border-t pt-4">
      <div className="flex justify-between">
        <Row md long />
        <Row md short />
      </div>
      <div className="flex justify-between">
        <Row md half />
        <Row md short />
      </div>

      <div className="bg-tertiary mt-3 h-10 w-full animate-pulse rounded-3xl" />
    </div>
  </div>
);
